<script>
    import Splitter from './LeftRightSplitter.svelte';
    import emotion from 'emotion/dist/emotion.umd.min.js';
    import Panel from './Panel.svelte';

    export let leftColumnWidth = 400;
    export let padded = true;
    export let onResize = () => {};
    export let minLeftWidth = 0;
    export let scrollableRightY = true;

    const { css } = emotion;

    $: if (leftColumnWidth < minLeftWidth) {
        leftColumnWidth = minLeftWidth;
    }

    const leftColumnCss = css`
        width: ${leftColumnWidth}px;
        min-width: ${minLeftWidth}px;
        background-color: #e9ecef;
        overflow-y: initial;
    `;
</script>

<style>
    .wrapper {
        flex: 1;
        flex-direction: row;
        height: 100%;
        display: flex;
    }

    .right-column {
        flex: 1;
        height: 100%;
        background-color: #fff;
    }

    .scrollable-y {
        overflow-y: scroll;
    }

    .padded {
        padding: 10px;
    }
</style>

<div class="wrapper" id='left-right-layout'>
    <div
        class="left-column {leftColumnCss}"
        class:padded>
        <slot name="left" />
    </div>
    <Splitter {onResize} />
    <div
        class="right-column"
        class:scrollable-y={scrollableRightY}
        class:padded>
        <slot name="right" />
    </div>
</div>
